<app-modals [title]="modalTitle" [description]="modalDescription" [config]="{ class: 'modal-lg' }" [openModal]="openModal" [closeModal]="closeModal" [whenModalClose]="whenModalClose" [submitKey]="submitKey" [onDismiss]="onDismiss" [isButtonsDisabled]="isButtonsDisabled" [showFooter]="activeTab === 0" [isShaking]="$safeNavigationMigration(errors?.length) > 0">
  <app-loading [isLoading]="isLoading">
    <div class="row">
      <div class="col-12">
        <tabset type="pills">
          @for (t of tabs; track t; let i = $index) {
            <tab [heading]="t.label | translate" [active]="t.isActive" (selectTab)="selectTab(i)"></tab>
          }
        </tabset>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        @if (activeTab === 0) {
          <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">
            <div class="form-check"><input class="me-2" id="send_to_root" type="checkbox" formControlName="send_to_root" /><label class="form-check-label" for="send_to_root">{{ 'MODALS.CUSTOM_NOTIFICATIONS.SEND_TO_ROOT' | translate }}</label></div>
            <div class="form-check"><input class="me-2" id="send_to_assigned" type="checkbox" formControlName="send_to_assigned" /><label class="form-check-label" for="send_to_assigned">{{ 'MODALS.CUSTOM_NOTIFICATIONS.SEND_TO_ASSIGNED' | translate }}</label></div>
            <div class="form-check"><input class="me-2" id="send_to_custom" type="checkbox" formControlName="send_to_custom" (change)="onCheckChanged()" /><label class="form-check-label mb-2" for="send_to_custom">{{ 'MODALS.CUSTOM_NOTIFICATIONS.SEND_TO_SELECTED' | translate }}</label></div>
            <div>
              <div class="mt-4">{{ 'MODALS.CUSTOM_NOTIFICATIONS.EMAILS_TITLE' | translate }}</div>
              <div formArrayName="email_notifications">
                @for (email of email_notifications.controls; track email; let i = $index) {
                  <div [formGroupName]="i">
                    <div class="row">
                      <div class="col-10 mt-2"><input class="form-control" id="custom_emails" type="text" formControlName="email" [placeholder]="'PLACEHOLDERS.ENTER_EMAIL' | translate" /></div>
                      <div class="col-2 mt-2"><button class="btn v-btn-danger" type="button" (click)="removeEmailField(i)" [disabled]="isEmailNotificationDisabled"><i class="lnr lnr-trash2"></i></button></div>
                    </div>
                  </div>
                }
              </div>
              <div class="row mb-3 mt-4 align-items-center">
                <div class="col-12 col-md-6"><button class="btn btn-sm v-btn-primary" type="button" [disabled]="isEmailNotificationDisabled" (click)="addEmailField()">{{ 'MODALS.CUSTOM_NOTIFICATIONS.ADD_EMAIL' | translate }}</button></div>
              </div>
            </div>
          </form>
        }

        @if (activeTab === 1) {
          <app-table [rows]="rows" [cols]="cols" [onButtonClick]="onButtonClick"></app-table>
        }
      </div>
    </div>
  </app-loading>
</app-modals>
